import React, { useState, useEffect } from "react";
import { Card, CardHeader, Table, Container, Row, Button } from "reactstrap";

const BonusesList = () => {
  const [bonuses, setBonuses] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");

  // Get token from localStorage
  const getToken = () => {
    return localStorage.getItem("token");
  };

  // Auth fetch function
  const authFetch = async (url, options = {}) => {
    const token = getToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      ...options.headers,
    };

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      throw new Error("Authentication failed");
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  };

  // Fetch bonuses from the API
  useEffect(() => {
    const fetchBonuses = async () => {
      try {
        const data = await authFetch(
          `${process.env.REACT_APP_API_URL}/bonuses`,
        );
        const currentDate = new Date();
        const updatedBonuses = data.bonuses.map((bonus) => {
          const bonusEndDate = new Date(bonus.end_date);
          if (currentDate >= bonusEndDate) {
            bonus.status = "Expired"; // Update expired status
          }
          return bonus;
        });
        setBonuses(updatedBonuses.reverse());
      } catch (error) {
        if (error.message !== "Authentication failed") {
          console.error("Error fetching bonuses:", error);
        }
      }
    };
    fetchBonuses();
  }, []);

  // Handle delete button click
  const handleDelete = async (bonusId) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this bonus?",
    );
    if (confirmation) {
      try {
        await authFetch(`${process.env.REACT_APP_API_URL}/bonuses/${bonusId}`, {
          method: "DELETE",
        });
        setBonuses((prevBonuses) =>
          prevBonuses.filter((bonus) => bonus.id !== bonusId),
        );
        alert("Bonus deleted successfully");
      } catch (error) {
        if (error.message !== "Authentication failed") {
          console.error("Error deleting bonus:", error);
          alert("Error deleting bonus");
        }
      }
    }
  };

  console.log("prevBonuses", bonuses);

  // Handle toggle status
  const toggleStatus = async (bonusId, currentStatus, one_time_use) => {
    const normalizedStatus = currentStatus;
    const newStatus = normalizedStatus === "active" ? "inactive" : "active";

    try {
      await authFetch(
        `${process.env.REACT_APP_API_URL}/bonuses/${bonusId}/status`,
        {
          method: "PUT",
          body: JSON.stringify({ status: newStatus, one_time_use }),
        },
      );

      setBonuses((prevBonuses) =>
        prevBonuses.map((bonus) =>
          bonus._id === bonusId
            ? {
                ...bonus,
                status: newStatus.charAt(0).toUpperCase() + newStatus.slice(1),
              }
            : bonus,
        ),
      );
      alert(
        `Bonus status updated to ${newStatus.charAt(0).toUpperCase() + newStatus.slice(1)}`,
      );
    } catch (error) {
      if (error.message !== "Authentication failed") {
        console.error("Error updating bonus status:", error);
        alert("Error updating bonus status");
      }
    }
  };

  // Filter bonuses based on status
  const filteredBonuses = bonuses.filter((bonus) => {
    if (filterStatus === "all") return true;
    return bonus.status === filterStatus;
  });

  return (
    <Container
      className=""
      style={{
        border: "none",
        backgroundColor: "rgba(1,1,1,0.2)",
        padding: "0",
        maxWidth: "100%",
      }}
    >
      <Row
        className=""
        style={{
          border: "none",
          backgroundColor: "rgba(1,1,1,0.2)",
          margin: "0",
        }}
      >
        <div className="col" style={{ padding: "0" }}>
          <Card
            className=""
            style={{ border: "none", backgroundColor: "rgba(1,1,1,0.2)" }}
          >
            <CardHeader
              className="border-0"
              style={{ backgroundColor: "rgba(1,1,1,0.2)", border: "none" }}
            >
              <h3
                className="mb-0"
                style={{
                  color: "white",
                  fontSize: "40px",
                  fontWeight: "bolder",
                }}
              >
                Bonuses List
              </h3>
              <div>
                <Button
                  color={filterStatus === "active" ? "primary" : "dark"}
                  onClick={() => setFilterStatus("active")}
                  style={{ marginRight: "10px" }}
                >
                  Active
                </Button>
                <Button
                  color={filterStatus === "inactive" ? "primary" : "dark"}
                  onClick={() => setFilterStatus("inactive")}
                  style={{ marginRight: "10px" }}
                >
                  Inactive
                </Button>
                <Button
                  color={filterStatus === "all" ? "primary" : "dark"}
                  onClick={() => setFilterStatus("all")}
                >
                  All
                </Button>
              </div>
            </CardHeader>
            <Table responsive style={{ width: "100%", tableLayout: "auto" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Bonus Code
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Start Date
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    End Date
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Bonus %
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Status
                  </th>
                  <th
                    style={{
                      color: "white",
                      fontSize: "0.7rem",
                      backgroundColor: "rgba(1,1,1,0.2)",
                      border: "none",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredBonuses.map((bonus) => (
                  <tr key={bonus.id} style={{ border: "none" }}>
                    <td style={{ color: "white", border: "none" }}>
                      {bonus.bonus_code}
                    </td>
                    <td style={{ color: "white", border: "none" }}>
                      {new Date(bonus.start_date).toLocaleDateString()}
                    </td>
                    <td style={{ color: "white", border: "none" }}>
                      {new Date(bonus.end_date).toLocaleDateString()}
                    </td>
                    <td style={{ color: "white", border: "none" }}>
                      {bonus.min_purchase_amount}
                    </td>
                    <td style={{ color: "white", border: "none" }}>
                      {bonus.bonus_percentage}%
                    </td>
                    <td style={{ color: "white", border: "none" }}>
                      {bonus.status}
                    </td>
                    <td style={{ border: "none" }}>
                      <Button
                        color="dark"
                        onClick={() => handleDelete(bonus._id)}
                      >
                        Delete
                      </Button>
                      {/* {bonus.status === "active" && (
                        <Button
                          color="dark"
                          onClick={() =>
                            toggleStatus(
                              bonus._id,
                              bonus.status,
                              bonus.one_time_use,
                            )
                          }
                          style={{ marginLeft: "10px" }}
                        >
                          Inactivate
                        </Button>
                      )} */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default BonusesList;
